// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vuex from 'vuex'
import App from './App'
import router from './router'
import './permission' // permission control
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.config.productionTip = false

// 获取cookie
import { setCookie, getCookie, delCookie } from '@/assets/js/cookie.js'

// 校验
import { 
  getAjax,
  getQueryString,
  isNull,
  regPhoneNumber,
  regIDFun,
  regmMailboxFun,
  timeReplacement,
  cutString,
  getCityChinese,
  showBigImg,
  loginOut,
  lshootMLink
} from '@/assets/js/check.js'

// axios
import '@/assets/js/lsajax.js'

// 使用获取cookie
Vue.prototype.setCookie = setCookie
Vue.prototype.getCookie = getCookie
Vue.prototype.delCookie = delCookie

// 使用校验
Vue.prototype.getAjax = getAjax
Vue.prototype.getQueryString = getQueryString
Vue.prototype.isNull = isNull
Vue.prototype.regPhoneNumber = regPhoneNumber
Vue.prototype.regIDFun = regIDFun
Vue.prototype.regmMailboxFun = regmMailboxFun
Vue.prototype.timeReplacement = timeReplacement
Vue.prototype.cutString = cutString
Vue.prototype.getCityChinese = getCityChinese
Vue.prototype.showBigImg = showBigImg
Vue.prototype.loginOut = loginOut
Vue.prototype.lshootMLink = lshootMLink


// 去除警告提示
Vue.config.productionTip = false

// 全局弹窗方法
Vue.prototype.tips = function (tips, duration = 1000 * 2) {

  this.bus.$emit('tips', { show: true, title: tips, duration })
}

// 全局loading方法
Vue.prototype.load = function (state = false, txt = '') {
  this.bus.$emit('load', { show: state, txt: txt })
}

// 中组站
Vue.prototype.bus = new Vue()
// 全局vuex
Vue.use(vuex)




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// 安卓判断
//if(/Android [4-6]/.test(navigator.appVersion)) {
  window.addEventListener("resize", function() {
    this.console.info('resize')
     // alert((document.body.height || document.body.clientHeight),  window.screen.height)
     if(document.activeElement.tagName=="INPUT" || document.activeElement.tagName=="TEXTAREA") {
        window.setTimeout(function() {
           document.activeElement.scrollIntoViewIfNeeded();
        },0);
     }
  })
//}


// WEBPACK FOOTER //
// ./src/main.js